import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';

export const patternValidator =
    (pattern: string | RegExp, message: string): ValidatorFn => (control: AbstractControl): ValidationErrors | null => {
        const validationErrors = Validators.pattern(pattern)(control);
        if (validationErrors) {
            return {
                pattern: message
            };
        }
        return null;
    };
